export const getPreferenceRows = (t, {
  hasUXRedesignTogglePaidFlag = false,
}) => {
  const baseRows = [{
    key: 'suggestNumbers',
    title: `Suggest ${t('Project')} Numbers and Cost Codes`,
    helpText: `With this setting enabled, the web app will suggest numbers for new ${t('Project', { count: 2 })} and Cost Codes by incrementing the previous number used in the series`,
    divider: false,
    useSwitch: true,
  }, {
    key: 'suggestUsernames',
    title: 'Suggest Usernames and Passwords',
    helpText: 'With this setting enabled, the web app will suggest a randomly generated username and password when creating a user',
    divider: false,
    useSwitch: true,
  }, {
    key: 'optionalUserEmail',
    title: 'Optional User Emails',
    helpText: 'With this setting enabled, users can be created without an email address. Users without an email will be assigned the company admin\'s email address',
    divider: false,
    useSwitch: true,
  }, {
    key: 'autoAddMetadataToPhotos',
    title: 'Auto Add Metadata to Photos',
    helpText: 'With this setting enabled, the app will automatically add metadata like location and timestamp to photos uploaded from the mobile app',
    divider: false,
    useSwitch: true,
  }];

  if (hasUXRedesignTogglePaidFlag) {
    baseRows.push({
      key: 'uxRedesignPt1',
      title: 'UI Redesign #1',
      helpText: 'With this setting enabled, the app will use the new UI redesign.',
      divider: false,
      useSwitch: true,
    });
  }

  return baseRows;
};

export const projectLabelFormatOptions = [
  {
    label: 'Name',
    value: 'name',
  },
  {
    label: 'Number',
    value: 'number',
  },
  {
    label: 'Both',
    value: 'both',
  },
];

export const equipmentLabelFormatOptions = [
  {
    label: 'Name',
    value: 'name',
  },
  {
    label: 'ID',
    value: 'id',
  },
  {
    label: 'Both',
    value: 'both',
  },
];

export default {};
